import { PostLampIcon } from './PostLampIcon';

/**
 * author: benjocaz45
 * id DA9F3CE2-81E2-4113-B8E7-64CE579D0890
 * name post-lamp
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post-lamp.svg
 * tags
 * - Home Automation 
 */
export const PostLightIcon = PostLampIcon;
export default PostLightIcon